export class QuarantineSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rows24h",
            "baseName": "rows24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "baseline24h",
            "baseName": "baseline24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "multiplier",
            "baseName": "multiplier",
            "type": "number",
            "format": "double"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QuarantineSummary.attributeTypeMap;
    }
    constructor() {
    }
}
